function handleSelectOptionChange(select, productId) {

  const product = shopBlindProducts.filter( sbProduct => sbProduct.id.toString() === productId.toString() )[0]
  
  const productVariants = typeof product.variants === 'string' ? JSON.parse(product.variants) : product.variants
  let availableOptions = []
  $(`#product-options-wrapper-${productId} .product-options-select`).each( (s, optSel) => {
    availableOptions.push($(optSel).val())
  })

  const currentIndex = $(select).data('select-index')
  let selectedOptions = []
  
  $(`#product-options-wrapper-${productId} #option-select-error-${currentIndex}`).hide()
  // Get all options selected at or above the current selector
  for ( let i = 1; i <= currentIndex; i++ ) {
      selectedOptions.push($(`#select-${productId}-${i}`).val())
  }

  $(select).parent().find('.product-options-select').each( (selIndex, selectOption) => {
      const selectIndex = $(selectOption).data('select-index')
      if ( selectIndex > currentIndex ) {
          $('option', selectOption).each( (o, option) => {
              if ( o === 0 ) return
              const optionText = $(option).text().trim()
              const optionsArr = selectedOptions.concat(optionText)
              let shouldShowOption = false
              let optionAvailable = false
              productVariants.forEach( variant => {
                  if ( JSON.stringify(variant.options) == JSON.stringify(optionsArr).replace("'", "/'") ) {
                      shouldShowOption = true
                      optionAvailable = variant.available
                  }
              })
              if ( !shouldShowOption ) {
                  //$(option).attr('disabled', !shouldShowOption)
                  $(option).hide()
              } else {
                  $(option).show()
                  if ( optionAvailable ) {
                    $(option).removeAttr('disabled')
                  } else {
                    $(option).attr('disabled', 'disabled')
                  }
              }
          })
      }
      if ( selIndex + 1 > currentIndex ) {
          $(`#select-${productId}-${selIndex + 1} option:first-of-type`).prop("selected", true).trigger('change');
      }
  })

  var id = '';
  productVariants.forEach( variant => {
    if ( JSON.stringify(variant.options) === JSON.stringify(availableOptions).replace("'", "/'") ) {
      id = variant.id;
    }
  })

  if (!id) {
    // Rondomize variant
    var availableVariants = productVariants.filter(
      variant => variant.options.some(option => availableOptions.filter(option => !!option).indexOf(option) >= 0)
    )
    if (availableVariants.length > 0) {
      var random = Math.floor(Math.random() * (availableVariants.length - 1)) + 1
      id = availableVariants[random].id
    }
  }

  const selectVal = document.getElementById(`product-select-${productId}`)
  if (id == '') {
    // Variant Not Found / Unavailable
    selectVal.value = '';
    // Disable Add To Cart Button Here
  } else if ($(`#product-select-${productId} option[value="${id}"]`).prop('disabled') == true) {
    // Sold Out
    selectVal.value = id;
    // Disable Add To Cart Button Here			
  } else {
    selectVal.value = id;
    // Enable Add To Cart Button Here
  }
}

const addItemToCart = (e, selectedVariant) => {
  const buttonLabel = $('[type="submit"]', e.target).val()
  $('[type="submit"]', e.target).addClass('loading').val('Adding To Cart')
  var payload = {
    quantity: 1,
    id: selectedVariant,
    properties: {
      '_shopblind': 'true'
    }
  }
  if ( product.selling_plan_id ) {
    payload.selling_plan = product.selling_plan_id
  }

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: payload,
    success: function (response) {
      $('.js-drawer-open-right').trigger('click')
      setTimeout( function () {
        $('[type="submit"]', e.target).removeClass('loading').val(buttonLabel)
        if ( !$(e.target).data('has-options') ) {
          $('.product-options-select', e.target).each( ( i, select ) => {
            $('option:first-of-type', select).prop("selected", true).trigger('change');
          })
        }
        closeDialog(e.target)
      }, 2000)
      return
    },
  });
}

$('.product-options-wrapper, .product-options-container-background, .product-options .close-button').on('click', function (e) {
  if ( e.target !== this ) return
  closeDialog(this)
})



function addProductToCart (product, variantId) {
    var payload = {
      quantity: 1,
      id: variantId.toString(),
      properties: {
      '_shopblind': 'true'
      }
    }
    if ( product.selling_plan_id ) {
      payload.selling_plan = product.selling_plan_id
    }

    addProduct( payload, product ).then( () => {
      var podcastPixel = new Image();
      podcastPixel.src="https://data.adxcel-ec2.com/pixel/?ad_log=referer&action=content&pixid=e503aefe-73f2-46f2-8010-e12740208050";
      return 'success'
  })
}

function stringToHtml (str) {
var dom = document.createElement('div');
dom.innerHTML = str;
return dom.textContent || dom.innerText;
}

function addProduct( postData, product ) {
    
    return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(postData)
    })
    .then(function(response) {
        return response.json();
    })
    .then(function(json) {
        // if (json.status && json.status !== 200) {
        //     var error = new Error(json.description);
        //     error.isFromServer = true;
        //     throw error;
        // }
        triggerKlaviyoViewedProduct (product)
        $('.js-drawer-open-right').trigger('click')
        // Close the currently open Shop Blind dialog after cart drawer opens
        setTimeout(function () {
          try {
            if (window.aria && typeof aria.closeCurrentDialog === 'function') {
              aria.closeCurrentDialog();
            }
          } catch (err) {
            // no-op
          }
        }, 300);
        return json
    })
    .catch(function(error) {
        console.error(error)
        // ShopifyAPI.onError(obj, status)
    })
}

function checkCartForRedundanciesV2 (product, options) {
return new Promise((resolve, reject) => {
  const matchedVariants = options.length
    ? product.variants.filter(variant => {
        const matchedOptions = variant.options.filter( option => {
          return options.includes(option)
        })
        return matchedOptions.length === options.length
      })
    : product.variants
  if ( matchedVariants.length === 1 ) {
    resolve(matchedVariants[0].id)
  }
  var variantIds = []
  matchedVariants.forEach( variant => {
    if ( variant.available ) {
      variantIds.push(variant.id)
    }
  })
  var mutableVariantIds = variantIds.slice(0)

  fetch('/cart.js')
  .then(function(response) {
    return response.json();
  })
  .then(function(cart) {
    var variantId = variantIds[0]
    cart.items.forEach( item => {
      // item.properties && ... Switch to if product type == shopblind
      if ( item.product_id === product.id && mutableVariantIds.includes(item.id) ) {
        var index = mutableVariantIds.indexOf(item.id)
        mutableVariantIds.splice(index, 1)
      }
    })
    // If all of the options are already in the cart, choose another one at random.
    if ( mutableVariantIds.length ) {
      variantId = mutableVariantIds[0]
    } else {
      var randomVariant = Math.floor(Math.random() * variantIds.length)
      variantId = variantIds[randomVariant]
    }
    resolve(variantId)
  })
  .catch(function(error) {
    // eslint-disable-next-line no-console
    console.error(error);
  });
})
// const postData = {
//   quantity: 1,
//   id: productToAdd[0].id
// }
}

function checkCartForRedundancies (product) {
var variantIds = []
product.variants.forEach( variant => {
  if ( variant.available ) {
    variantIds.push(variant.id)
  }
})
var mutableVariantIds = variantIds
return fetch('/cart.js')
.then(function(response) {
  return response.json();
})
.then(function(cart) {
  var itemCount = 0
  var groupedProductIds = []
  var variantId = variantIds[0]
  cart.items.forEach( item => {
    // item.properties && ... Switch to if product type == shopblind
    if ( item.product_id === product.id && mutableVariantIds.includes(item.id) ) {
      var index = mutableVariantIds.indexOf(item.id)
      mutableVariantIds.splice(index, 1)
    }
  })
  // If all of the options are already in the cart, choose another one at random.
  if ( mutableVariantIds.length === variantIds.length ) {
    var randomVariant = Math.floor(Math.random() * variantIds.length)
    variantId = variantIds[randomVariant]
  } else {
    var randomVariant = Math.floor(Math.random() * mutableVariantIds.length)
    variantId = mutableVariantIds[randomVariant]
  }
  return variantId
})
.catch(function(error) {
  // eslint-disable-next-line no-console
  console.error(error);
});
}

function triggerKlaviyoViewedProduct (product) {

var item = {
  ProductName: product.title,
  ProductID: product.id,
  Categories: ['shop blind'],
  ImageURL: product.image,
  URL: "https://twoblindbrothers.com",
  Brand: product.vendor,
  Price: product.price
};
klaviyo.push(['track', 'Added to Cart', item]);

}  